import React from 'react'
import GatsbyImage, { GatsbyImageProps } from 'gatsby-image'
import Scroll from './Scroll'
import { OutboundLink } from 'gatsby-plugin-google-gtag'
import New from './New'

type Props = {
  next: string
  image?: GatsbyImageProps['fluid']
  title: string
  link?: string
  isFirst?: boolean
}

const Section: React.FC<Props> = ({
  next,
  image,
  title,
  link,
  children,
  isFirst,
}) => (
  <section id={encodeURIComponent(title)} className="main special">
    <div className="container">
      {isFirst && (
        <header className="major">
          <h2>Songs</h2>
        </header>
      )}
      {image && (
        <span className="image fit primary">
          {link ? (
            <OutboundLink href={link}>
              <GatsbyImage fluid={image} />
            </OutboundLink>
          ) : (
            <GatsbyImage fluid={image} />
          )}
        </span>
      )}
      <div className="content">
        <header className="major">
          {isFirst && <New>New!</New>}
          <h2>
            {link ? <OutboundLink href={link}>{title}</OutboundLink> : title}
          </h2>
        </header>
        {children}
      </div>
      <Scroll type="id" element={encodeURIComponent(next)}>
        <a href={`#${encodeURIComponent(next)}`} className="goto-next ">
          Next
        </a>
      </Scroll>
    </div>
  </section>
)

export default Section
